module.exports = __webpack_public_path__ + "static/media/imagarena_text_logo_dev.5016a372.png";